import { Auth } from 'aws-amplify';
import appConfig from '../../../../config/app-config';

const { address: API_URL, key: API_KEY } = appConfig.apis.billing;

const getHeaders = async () => {
    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();
    return {
        'x-api-key': API_KEY,
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
    };
};

export interface ReceivingBankAccountPayload {
    exibition_name: string;
    alias_name: string;   // imutável após a criação: o backend recusa alteração
    bank_name?: string;
    /** qual BANCO (ITAU, STARKBANK…); o `alias_name` diz qual CONTA. Vazio limpa. */
    bank_tag?: string | null;
    /** a conta tem contas Escrow: o pagamento que entra nela pode ser marcado como escrow (AF-4155) */
    escrow_account_support?: boolean;
}

const parseOrThrow = async (res: Response) => {
    if (!res.ok) {
        const body = await res.json().catch(() => null);
        throw new Error(body?.message || `Erro HTTP ${res.status}`);
    }
    return res.json();
};

export interface ReceivingBankAccount {
    id: number;
    receivingBankAccountId: string;
    bankName?: string;
    exibitionName: string;
    aliasName: string;
    bankTag?: string | null;
    active: boolean;
    escrowAccountSupport?: boolean;
}

/** Por padrão devolve só as contas ativas — conta desativada não é ofertada em novo pagamento. */
export const listReceivingBankAccounts = async (onlyActive = true): Promise<ReceivingBankAccount[]> => {
    const headers = await getHeaders();
    const query = `size=200&sort=alias_name${onlyActive ? '&filter[active]=true' : ''}`;
    const res = await fetch(`${API_URL}/receiving-bank-accounts?${query}`, { headers });
    const data = await parseOrThrow(res);
    return data.list || [];
};

export const createReceivingBankAccount = async (payload: ReceivingBankAccountPayload) => {
    const headers = await getHeaders();
    const res = await fetch(`${API_URL}/receiving-bank-accounts`, {
        method: 'POST', headers, body: JSON.stringify(payload),
    });
    return parseOrThrow(res);
};

export const updateReceivingBankAccount = async (ref: string | number, payload: ReceivingBankAccountPayload) => {
    const headers = await getHeaders();
    const res = await fetch(`${API_URL}/receiving-bank-accounts/${ref}`, {
        method: 'PUT', headers, body: JSON.stringify(payload),
    });
    return parseOrThrow(res);
};

/**
 * Ativa/desativa a conta. Não existe exclusão: pagamentos já registrados a referenciam.
 */
export const setReceivingBankAccountActive = async (ref: string | number, active: boolean) => {
    const headers = await getHeaders();
    const res = await fetch(`${API_URL}/receiving-bank-accounts/${ref}/active`, {
        method: 'PATCH', headers, body: JSON.stringify({ active }),
    });
    return parseOrThrow(res);
};
